import {
  Chain,
  Wallet,
  connectorsForWallets,
  getDefaultWallets,
  getWalletConnectConnector,
} from '@rainbow-me/rainbowkit';
import '@rainbow-me/rainbowkit/styles.css';
import {
  binanceWallet,
  metaMaskWallet,
  okxWallet,
  safepalWallet,
  trustWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
import { createConfig, createStorage, http } from 'wagmi';
import { bsc } from 'wagmi/chains';
import { STAGE } from '../constants/api';
import { MetaMaskWalletOptions } from '@rainbow-me/rainbowkit/dist/wallets/walletConnectors/metaMaskWallet/metaMaskWallet';

export type WagmiConnectors = {
  name: string;
};

export const networks = {
  development: {
    ...bsc,
  },
  production: {
    ...bsc,
  },
};

export const TARGET_NETWORKS = networks[STAGE];

const projectId = 'b768bdba181400c7a5b7ddc9fe4f5ca9';

const chains: readonly [Chain, ...Chain[]] = [TARGET_NETWORKS];

export interface MyWalletOptions {
  projectId: string;
}
export const cryptocom = ({ projectId }: MyWalletOptions): Wallet => ({
  id: 'cryptocom',
  name: 'Crypto.com',
  iconUrl:
    'https://explorer-api.walletconnect.com/v3/logo/lg/7c5ff577-a68d-49c5-02cd-3d83637b0b00?projectId=2f05ae7f1116030fde2d36508f472bfb',
  iconBackground: '#fffff',
  downloadUrls: {
    android: 'https://play.google.com/store/apps/details?id=com.defi.wallet',
    ios: 'https://apps.apple.com/us/app/crypto-com-l-defi-wallet/id1512048310?mt=8',
    qrCode: 'https://crypto.com/defi-wallet',
  },
  mobile: {
    getUri: (uri: string) => `defiwallet://wc?uri=${encodeURIComponent(uri)}`,
  },
  qrCode: {
    getUri: (uri: string) => uri,
  },
  createConnector: getWalletConnectConnector({
    projectId,
  }),
});

export const walletConnectWalletCustom = ({
  projectId,
}: MyWalletOptions): Wallet => ({
  ...walletConnectWallet({
    projectId,
  }),
  createConnector: getWalletConnectConnector({ projectId }),
});

export const metaMaskCustom = ({
  projectId,
}: MetaMaskWalletOptions): Wallet => ({
  ...metaMaskWallet({ projectId }),
  mobile: {
    getUri: (uri: string) => `metamask://wc?uri=${encodeURIComponent(uri)}`,
  },
  createConnector: getWalletConnectConnector({
    projectId,
  }),
  qrCode: {
    getUri: (uri: string) => uri,
  },
});

const { wallets } = getDefaultWallets({
  appName: 'AGNT',
  projectId: projectId,
});

export const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommended',
      wallets: [
        binanceWallet,
        metaMaskCustom,
        walletConnectWallet,
        safepalWallet,
        trustWallet,
        okxWallet,
      ],
    },
    { groupName: 'Others', wallets: [...wallets[0].wallets] },
  ],
  {
    projectId: projectId,
    appName: 'AGNT',
  }
);

export const wagmiConfig = createConfig({
  chains: chains,
  connectors,
  transports: {
    ...chains.reduce((acc, chain) => {
      acc[chain.id] = http();
      return acc;
    }, {} as Record<Chain['id'], ReturnType<typeof http>>),
    [bsc.id]: http('https://bsc-mainnet.public.blastapi.io'),
  },
});

export const walletsList = [
  {
    name: 'MetaMask',
    id: 'metaMask',
  },
  {
    name: 'Trust Wallet',
    id: 'trust',
  },
  {
    name: 'Coinbase Wallet',
    id: 'coinbase',
  },
  {
    name: 'WalletConnect',
    id: 'walletConnect',
  },
  {
    name: 'Crypto.com',
    id: 'cryptocom',
  },
];
